import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { useProfile } from '../profile/hooks';
import { StudentActivity } from '../student/StudentActivity';
import { NoActivity } from '../../components/activity/NoActivity';

export const Activity = () => {
    const theme = useTheme();
    const { profile } = useProfile();

    return (
        <Box
            sx={{
                padding: '0px 20px',
                [theme.breakpoints.down('md')]: {
                    padding: '0px',
                },
            }}>
            <div className='question header-container'>
                <div className='header'>
                    <Typography
                        align="left"
                        variant="h1"
                        color="primary.blue"
                        sx={{
                            margin: '0',
                            fontWeight: '700',
                            lineHeight: '1.5',
                            fontSize: '2rem',
                        }}>My Activity</Typography>
                </div>
                {profile && Object.keys(profile).length > 0 ?
                    <StudentActivity studentId={profile?.id} passedOnly />
                    : <NoActivity />}
            </div>
        </Box >
    )
}


const styles = {
    label: {
        color: 'var(--mui-palette-common-black)',
        fontWeight: 'bold'
    },
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'
    },
    gridContainer: {
        mt: 2,
        display: 'flex'
    },
    suggestionBox: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        marginTop: '10px',
    },
    suggestionItem: {
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '2px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px var(--mui-palette-secondary-boxShadow1)',
        backgroundColor: 'var(--mui-palette-gray-lightGrey300)',
    },
    uploadBtn: {
        width: '50px',
        height: '50px',
        borderRadius: '5px',
    },
    hiddenInput: {
        display: 'none',
    }
};